import UserBuilderPage from "../../features/user-builder/pages/UserBuilderPage";
import MembershipControlPage from "../../features/memberships/pages/MembershipControlPage";
import MembershipApplyPage from "../../features/memberships/pages/MembershipApplyPage";
import MembershipRenewPage from "../../features/memberships/pages/MembershipRenewPage";
import MembershipPaymentsPage from "../../features/memberships/pages/MembershipPaymentsPage";
import MembershipsListPage from "../../features/memberships/pages/MembershipsListPage";
import MyMembershipsPage from "../../features/memberships/pages/MyMembershipsPage";
import TournamentControlPage from "../../features/tournaments/pages/TournamentControlPage";
import TournamentRegistrationPage from "../../features/tournaments/pages/TournamentRegistrationPage";
import TournamentResultsPage from "../../features/tournaments/pages/TournamentResultsPage";
import ParticipantsListPage from "../../features/tournaments/pages/ParticipantsListPage";
import TournamentPaymentsPage from "../../features/tournaments/pages/TournamentPaymentsPage";
import MyTournamentsPage from "../../features/tournaments/pages/MyTournamentsPage";
import RegisterControlPage from "../../features/inward-outward/pages/RegisterControlPage";
import InwardsRegisterPage from "../../features/inward-outward/pages/InwardsRegisterPage";
import OutwardsRegisterPage from "../../features/inward-outward/pages/OutwardsRegisterPage";
import CallLogsControlPage from "../../features/call-logs/pages/CallLogsControlPage";
import CallLogsPage from "../../features/call-logs/pages/CallLogsPage";
import MaintenanceControlPage from "../../features/maintenance/pages/MaintenanceControlPage";
import MaintenanceRecordsPage from "../../features/maintenance/pages/MaintenanceRecordsPage";
import ToAndFroControlPage from "../../features/to-and-fro/pages/ToAndFroControlPage";
import ToAndFroRegisterPage from "../../features/to-and-fro/pages/ToAndFroRegisterPage";
import DonorsListPage from "../../features/donor-support/pages/DonorsListPage";
import DonationsControlPage from "../../features/donor-support/pages/DonationsControlPage";
import DonorEquipmentListPage from "../../features/donor-support/pages/DonorEquipmentListPage";
import DonationPaymentsPage from "../../features/donor-support/pages/DonationPaymentsPage";
import StudentRegistrationsPage from "../../features/student-registrations/pages/StudentRegistrationsPage";
import ChequeIssuesWorkspacePage from "../../features/cheques/pages/ChequeIssuesWorkspacePage";
import FinancePaymentsControlPage from "../../features/finance-payments/pages/FinancePaymentsControlPage";
import CertificateTemplatesPage from "../../features/certificates/pages/CertificateTemplatesPage";
import DonorDonationHistory from "../../features/donor-portal/pages/DonorDonationHistory";
import DonorDonationTracking from "../../features/donor-portal/pages/DonorDonationTracking";
import NotificationsPage from "../../features/notifications/pages/NotificationsPage";
import VisitorControlPage from "../../features/visitor/pages/VisitorControlPage";
import VisitorRegisterPage from "../../features/visitor/pages/VisitorRegisterPage";
import VisitorsHubPage from "../../features/visitor/pages/VisitorsHubPage";
import ScheduleControlPage from "../../features/schedule/pages/ScheduleControlPage";
import ScheduleEntryPage from "../../features/schedule/pages/ScheduleEntryPage";
import PropertyAssetsControlPage from "../../features/property-assets/pages/PropertyAssetsControlPage";
import PropertyAssetsSubAdminPage from "../../features/property-assets/pages/PropertyAssetsSubAdminPage";
import AttendanceControlPage from "../../features/attendance/pages/AttendanceControlPage";
import AttendanceMarkPage from "../../features/attendance/pages/AttendanceMarkPage";
import AttendanceReportPage from "../../features/attendance/pages/AttendanceReportPage";
import AttendanceApplyLeavePage from "../../features/attendance/pages/AttendanceApplyLeavePage";
import AttendanceLeaveManagerPage from "../../features/attendance/pages/AttendanceLeaveManagerPage";
import SettingsPage from "../../features/settings/pages/SettingsPage";

/** Authenticated screens at /app/<path> (no role prefix in URL). */
export const APP_SCREEN_ROUTES = [
  {
    path: "user-builder",
    screenKey: "user-control",
    element: UserBuilderPage,
  },
  {
    path: "settings",
    screenKey: "settings",
    element: SettingsPage,
  },
  {
    path: "notifications",
    screenKey: "notifications",
    element: NotificationsPage,
  },
  {
    path: "memberships/control",
    screenKey: "memberships-control",
    element: MembershipControlPage,
  },
  {
    path: "memberships/apply",
    screenKey: "apply-membership",
    element: MembershipApplyPage,
  },
  {
    path: "memberships/renew",
    screenKey: "membership-renewals",
    element: MembershipRenewPage,
  },
  {
    path: "memberships/list",
    screenKey: "memberships-list",
    element: MembershipsListPage,
  },
  {
    path: "memberships/payments",
    screenKey: "membership-payments",
    element: MembershipPaymentsPage,
  },
  {
    path: "memberships/my-memberships",
    screenKey: "my-memberships",
    element: MyMembershipsPage,
  },
  {
    path: "tournaments/control",
    screenKey: "tournaments-control",
    element: TournamentControlPage,
  },
  {
    path: "tournaments/register",
    screenKey: "tournament-registration",
    element: TournamentRegistrationPage,
  },
  {
    path: "tournaments/participants",
    screenKey: "participants-list",
    element: ParticipantsListPage,
  },
  {
    path: "tournaments/results",
    screenKey: "tournament-results",
    element: TournamentResultsPage,
  },
  {
    path: "tournaments/payments",
    screenKey: "tournament-payments",
    element: TournamentPaymentsPage,
  },
  {
    path: "tournaments/my-tournaments",
    screenKey: "my-tournaments",
    element: MyTournamentsPage,
  },
  {
    path: "inward-outward/register",
    screenKey: "inward-outward-register",
    element: RegisterControlPage,
  },
  {
    path: "inward-outward/inwards",
    screenKey: "inwards-register",
    element: InwardsRegisterPage,
  },
  {
    path: "inward-outward/outwards",
    screenKey: "outwards-register",
    element: OutwardsRegisterPage,
  },
  {
    path: "call-logs/control",
    screenKey: "phone-call-logs-control",
    element: CallLogsControlPage,
  },
  {
    path: "call-logs",
    screenKey: "phone-call-logs",
    element: CallLogsPage,
  },
  {
    path: "maintenance/control",
    screenKey: "maintenance-records-control",
    element: MaintenanceControlPage,
  },
  {
    path: "maintenance",
    screenKey: "maintenance-records",
    element: MaintenanceRecordsPage,
  },
  {
    path: "to-and-fro/control",
    screenKey: "tos-fros-control",
    element: ToAndFroControlPage,
  },
  {
    path: "to-and-fro",
    screenKey: "tos-fros",
    element: ToAndFroRegisterPage,
  },
  {
    path: "donor-support/donors",
    screenKey: "donors-list",
    element: DonorsListPage,
  },
  {
    path: "donor-support/donations",
    screenKey: "donations-control",
    element: DonationsControlPage,
  },
  {
    path: "donor-support/collect-donations",
    screenKey: "collect-donations",
    element: DonationsControlPage,
  },
  {
    path: "donor-support/donation-tracking",
    screenKey: "donation-tracking",
    element: DonationsControlPage,
  },
  {
    path: "donor-support/equipment",
    screenKey: "donor-equipment-list",
    element: DonorEquipmentListPage,
  },
  {
    path: "donor-support/payments",
    screenKey: "donations",
    element: DonationPaymentsPage,
  },
  {
    path: "member-registrations",
    screenKey: "member-registration",
    element: StudentRegistrationsPage,
  },
  {
    path: "finance-payments",
    screenKey: "finance-payments",
    element: FinancePaymentsControlPage,
  },
  {
    path: "cheques/issues",
    screenKey: "cheque-issues",
    element: ChequeIssuesWorkspacePage,
  },
  {
    path: "cheques/control",
    screenKey: "cheque-issues",
    element: ChequeIssuesWorkspacePage,
  },
  {
    path: "cheques",
    screenKey: "cheque-issues",
    element: ChequeIssuesWorkspacePage,
  },
  {
    path: "certificates/templates",
    screenKey: "certificate-templates",
    element: CertificateTemplatesPage,
  },
  {
    path: "donor-portal/donation-history",
    screenKey: "donation-history",
    element: DonorDonationHistory,
  },
  {
    path: "donor-portal/donation-tracking",
    screenKey: "donor-donation-tracking",
    element: DonorDonationTracking,
  },

  {
    path: "visitors/control",
    screenKey: "visitor-control",
    element: VisitorControlPage,
  },
  {
    path: "visitors/register",
    screenKey: "visitor-register",
    element: VisitorRegisterPage,
  },
  {
    path: "visitors",
    screenKey: "visitor-list",
    element: VisitorsHubPage,
  },
  {
    path: "schedules/control",
    screenKey: "schedule-control",
    element: ScheduleControlPage,
  },
  {
    path: "schedules",
    screenKey: "schedule-entry",
    element: ScheduleEntryPage,
  },
  {
    path: "property-assets/control",
    screenKey: "property-assets-control",
    element: PropertyAssetsControlPage,
  },
  {
    path: "property-assets",
    screenKey: "property-assets",
    element: PropertyAssetsSubAdminPage,
  },
  {
    path: "attendance/control",
    screenKey: "attendance-control",
    element: AttendanceControlPage,
  },
  {
    path: "attendance/mark",
    screenKey: "attendance-mark",
    element: AttendanceMarkPage,
  },
  {
    path: "attendance/report",
    screenKey: "attendance-report",
    element: AttendanceReportPage,
  },
  {
    path: "attendance/apply-leave",
    screenKey: "attendance-apply-leave",
    element: AttendanceApplyLeavePage,
  },
  {
    path: "attendance/leave-manager",
    screenKey: "attendance-leave-manager",
    element: AttendanceLeaveManagerPage,
  },
];
